import Icon from '../components/Icon'

Icon.register({
  'head-side-cough-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M454.1 319.2l179.7 138.9c3.8 2.9 6.2 7.5 6.2 12.6 0 3.7-1.3 7.1-3.4 9.8l-19.6 25.3c-2.9 3.8-7.5 6.2-12.7 6.2-3.7 0-7.1-1.3-9.8-3.4l-588.4-454.7c-3.8-2.9-6.2-7.5-6.2-12.6 0-3.7 1.3-7.1 3.4-9.8l19.6-25.3c2.9-3.8 7.5-6.2 12.6-6.2 3.7 0 7.1 1.3 9.8 3.4l38.7 29.9c30.6-20.9 67.8-33.3 107.6-33.3h0.2 42.1c70.3 0 132.3 34.8 170 88.3 24.6 35 52.1 139.6 73.1 186.8 8.5 19.2-3.5 40.4-23.1 44.2zM313.4 210.4c3.9-5.3 6.6-11.5 6.6-18.5 0-17.6-14.4-32-32-32-9.9 0-18.5 4.9-24.4 12zM616 304c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24zM552 368c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24zM288 384c0 17.7 14.3 32 32 32h96c0 35.3-28.7 64-64 64h-64v32h-224v-177.1c-39.3-35.3-64-86.1-64-142.9 0-31 7.6-60.5 20.7-86.4l318.8 246.4h-19.5c-17.7 0-32 14.3-32 32zM616 360c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24z'
      }
    ]
  }
})
